module.exports = __webpack_public_path__ + "img/cantante-leggera-cerimonia.fa158e2b.jpg";